import { EULERIAN_ACCOMMODATION_TYPE } from '@spa/shared/constants/eulerian';

export const mapFiltersAppliedEventData = ({
  ['move-in']: move_in,
  ['move-out']: move_out,
  ['budget-min']: budget_minimum,
  ['budget-max']: budget_maximum,
  ['has-trusted-landlord']: has_trusted_landlord,
  ['has-checked-place']: has_checked_place,
  ['has-resident-landlord']: has_resident_landlord,
  ['instant-bookings']: is_instant_booking,
  bathrooms: number_of_bathrooms,
  bedrooms: number_of_bedrooms,
  ['housing-type']: accommodation_types = [],
  ['rent-type']: rent_types = [],
  ['restrictions-occupation']: occupation_restrictions = [],
  ['restrictions-occupancy']: occupancy_restrictions = [],
  ['restrictions-gender']: gender_restrictions = [],
  ['bills-included']: bills_included,
  ['offer-features']: offerFeatures = [],
  ['property-features']: propertyFeatures = [],
  ['bed-type']: bedroom_bed_types = [],
  guests,
  rules = []
}) => {
  return [
    ...generateSearchTag('filter_number_of_people', guests),
    ...generateSearchTag('filter_budget_min', budget_minimum ?? (budget_maximum ? 0 : undefined)),
    ...generateSearchTag('filter_budget_max', budget_maximum),
    ...generateSearchTag('filter_move_in', move_in?.replace(/-/g, '')),
    ...generateSearchTag('filter_move_out', move_out?.replace(/-/g, '')),
    ...generateSearchTag('filter_bills_included', bills_included),
    ...generateSearchTag('filter_accomodation_feature_trusted_landlord', has_trusted_landlord),
    ...generateSearchTag('filter_accomodation_feature_instant_booking', is_instant_booking),
    ...generateSearchTag('filter_accomodation_feature_checked_place', has_checked_place),
    ...generateSearchTag('filter_accomodation_feature_landlord_not_at_property', has_resident_landlord),
    ...generateSearchTag('filter_gender', !!gender_restrictions.length),
    ...generateSearchTag('filter_residence', accommodation_types.includes('residence')),
    ...generateSearchTag('filter_accomodation_feature_couples_allowed', occupancy_restrictions.includes('couples')),

    ...(number_of_bedrooms ? generateSearchTag('filter_typology_bedrooms', `${number_of_bedrooms[0]} Bedrooms`) : []),

    ...(number_of_bathrooms
      ? generateSearchTag('filter_typology_bathrooms', `${number_of_bathrooms[0]} Bathrooms`)
      : []),

    ...occupation_restrictions.reduce(
      (acc, occupation) => [...acc, ...generateSearchTag(`filter_user_type_${occupation.replace(/-/g, '_')}`, true)],
      []
    ),

    ...rent_types.reduce(
      (acc, rentType) => [
        ...acc,
        ...generateSearchTag(`filter_type_of_accommodation_${EULERIAN_ACCOMMODATION_TYPE[rentType]}`, true)
      ],
      []
    ),

    ...rules.reduce((acc, rule) => {
      if (rule === 'pets-allowed') {
        return [...acc, ...generateSearchTag('filter_accomodation_feature_pet_friendly', true)];
      }

      return [...acc, ...generateSearchTag(`filter_accomodation_feature_${rule.replace(/-/g, '_')}`, true)];
    }, []),

    ...offerFeatures.reduce((acc, feature) => {
      if (feature === 'wardrobe') {
        return [...acc, ...generateSearchTag('filter_bedroom_features_wardrobe', true)];
      }

      return [...acc, ...generateSearchTag(`filter_accomodation_feature_${feature.replace(/-/g, '_')}`, true)];
    }, []),

    ...bedroom_bed_types.reduce(
      (acc, type) => [...acc, 'isearchkey', `filter_bedroom_features_${type.replace(/-/g, '_')}`, 'isearchdata', true],
      []
    ),

    ...propertyFeatures.reduce((acc, feature) => {
      if (feature === 'wi-fi') {
        return [...acc, ...generateSearchTag('filter_accomodation_feature_wifi', true)];
      }

      if (feature === 'cable-tv') {
        return [...acc, ...generateSearchTag('filter_accomodation_feature_tv', true)];
      }

      return [...acc, ...generateSearchTag(`filter_accomodation_feature_${feature.replace(/-/g, '_')}`, true)];
    }, [])
  ];
};

export const generateSearchTag = (key, data) => (data ? ['isearchkey', key, 'isearchdata', data] : []);
